<div class="reset-form-email">
  {{ email }}
</div>

<form
  nz-form
  [formGroup]="resetForm"
  class="reset-form"
  (ngSubmit)="submitForm()"
>
  <nz-form-item>
    <nz-form-control [nzErrorTip]="passwordErrorTpl">
      <nz-input-group
        [nzPrefix]="lockPrefixTemplate"
        [nzSuffix]="eyeSuffixTemplate"
      >
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          nz-input
          formControlName="password"
          [placeholder]="'FORM.LABEL.PASSWORD' | translate"
        />
      </nz-input-group>
      <ng-template #eyeSuffixTemplate>
        <i
          class="cursor-pointer fal"
          [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"
          (click)="passwordVisible = !passwordVisible"
        ></i>
      </ng-template>
      <ng-template #lockPrefixTemplate>
        <i class="fal fa-lock"></i>
      </ng-template>
      <ng-template #passwordErrorTpl let-control>
        <ng-container *ngIf="control.hasError('maxlength')">
          {{ "FORM.ERR.MAX_CHARS" | translate: { value: 40 } }}
        </ng-container>
        <ng-container *ngIf="control.hasError('minlength')">
          {{ "FORM.ERR.MIN_CHARS" | translate: { value: 8 } }}
        </ng-container>
        <ng-container *ngIf="control.hasError('required')">
          {{ "FORM.ERR.REQUIRED_PASS" | translate }}
        </ng-container>
        <ng-container
          *ngIf="
            !control.hasError('required') &&
            !control.hasError('minlength') &&
            !control.hasError('maxlength') &&
            control.hasError('pattern')
          "
        >
          {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.ERROR" | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control [nzErrorTip]="confirmPasswordErrorTpl">
      <nz-input-group
        [nzPrefix]="lockPrefixTemplate"
        [nzSuffix]="eyeSuffix2Template"
      >
        <input
          formControlName="confirmPassword"
          [type]="confirmPasswordVisible ? 'text' : 'password'"
          nz-input
          [placeholder]="'FORM.LABEL.CONFIRM_PASSWORD' | translate"
        />
      </nz-input-group>
      <ng-template #eyeSuffix2Template>
        <i
          class="cursor-pointer fal"
          [ngClass]="confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
          (click)="confirmPasswordVisible = !confirmPasswordVisible"
        ></i>
      </ng-template>
      <ng-template #lockPrefixTemplate>
        <i class="fal fa-lock"></i>
      </ng-template>
      <ng-template #confirmPasswordErrorTpl let-control>
        <ng-container *ngIf="control.hasError('equalTo')">
          {{ "FORM.ERR.PASSWORDS_DO_NOT_MATCH" | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-control>
      <button
        [nzLoading]="isSubmitting"
        [disabled]="!resetForm.valid"
        nz-button
        class="reset-password-form-button"
        [nzType]="'primary'"
      >
        {{ "PAGE.AUTH.RESET_PASSWORD.SUBMIT" | translate }}
      </button>
    </nz-form-control>
  </nz-form-item>
</form>
